import { IOption } from 'interfaces';
import Countries from 'data/countries-cities.json';

/**
 * @param  {any} e The options in enum
 * @returns IOption
 */
export function getOptionsFromEnum(e:any):IOption[] {
  const values = Object.values(e);
  const options:IOption[] = [];
  values.forEach((value, index) => {
    const text = value as string;
    options.push({
      id: index + 1,
      value: text,
      text: text.charAt(0).toUpperCase() + text.slice(1),
    });
  });
  return options;
}

/**
 * returns all the countries
 */
export function getCountries():string[] {
  return Object.keys(Countries);
}

/**
 * @param  {string} country Country which the cities are required
 */
export function getCitiesForCountry(country:string) {
  return Array.from(new Set(Object.values(Countries[country as keyof typeof Countries])));
}

/**
 * return the SLUG of the text
 */
export function slugify(...args: (string | number)[]): string {
  const str = args.join(' ');
  let slug = str.replace(/^\s+|\s+$/g, ''); // trim
  slug = slug.toLowerCase();

  // remove accents, swap ñ for n, etc
  const from = 'àáäâèéëêìíïîòóöôùúüûñç·/_,:;';
  const to = 'aaaaeeeeiiiioooouuuunc------';
  // eslint-disable-next-line no-plusplus
  for (let i = 0, l = from.length; i < l; i++) {
    slug = slug.replace(new RegExp(from.charAt(i), 'g'), to.charAt(i));
  }

  slug = slug.replace(/[^a-z0-9 -]/g, '') // remove invalid chars
    .replace(/\s+/g, '-') // collapse whitespace and replace by -
    .replace(/-+/g, '-'); // collapse dashes

  return slug;
}

export function getTotalFromArray(arr: number[]) {
  if (!Array.isArray(arr)) {
    throw new Error('Input must be an array');
  }
  const total = arr.reduce((accumulator, currentValue) => accumulator + currentValue, 0);
  return total;
}
